import { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { signOptions } from "../../../pages/database/dto";
import { CoinStackIcon } from "../../../ui/icons/coinStack";
import { SelectCustom } from "../../../ui/molecules/select";
import { AccordionFilter } from "../../../ui/organisms/accordionFilter";
import { FindAllContactsFilters } from "../dto";

interface Props {
    updateFilters: (filter: Partial<FindAllContactsFilters>) => void
    filters: FindAllContactsFilters
    clearAll: boolean
}

export function RevenueFilter(props: Props) {
    const { updateFilters, filters, clearAll } = props

    const [sign, setSign] = useState<'=' | '<' | '>' | '><' | undefined>(undefined);
    const [firstInput, setFirstInput] = useState<number | undefined>(undefined);
    const [secondInput, setSecondInput] = useState<number | undefined>(undefined);

    useEffect(() => {
        let value = sign === undefined ? undefined : sign + (firstInput?.toString() ? ':' + firstInput.toString() : '') + (sign === '><' && secondInput?.toString() ? ':' + secondInput.toString() : '')
        let label = signOptions.find(opt => opt.value === sign)?.label + (firstInput ? ' € ' + firstInput.toLocaleString('it-IT', { useGrouping: true, maximumFractionDigits: 2, minimumFractionDigits: 2 }) : '') + (sign === '><' && secondInput ? ' e € ' + secondInput.toLocaleString('it-IT', { useGrouping: true, maximumFractionDigits: 2, minimumFractionDigits: 2 }) : '')
        if (value === undefined && filters.companyRevenue === undefined) {
            return
        }
        if (value === undefined) {
            updateFilters({ companyRevenue: undefined })
        } else {
            updateFilters({ companyRevenue: { label: label, value: value } })
        }
    }, [sign, firstInput, secondInput])

    const handleClear = () => {
        setFirstInput(undefined);
        setSecondInput(undefined);
        setSign(undefined)
        updateFilters({ companyRevenue: undefined })
    };

    useEffect(() => {
        if (clearAll) {
            handleClear();
        }
    }, [clearAll]);

    return (
        <AccordionFilter
            key={'person-filter-revenue'}
            label={"Fatturato"}
            icon={<CoinStackIcon color={""} size={0} />}
            showClear={filters.companyRevenue !== undefined}
            options={filters.companyRevenue !== undefined ? [filters.companyRevenue] : []}
            clearAction={handleClear}
            deleteFilter={handleClear}
        >
            <div className="flex flex-col gap-4">
                <SelectCustom
                    isSearchable={false}
                    onChange={(e) => {
                        if (e !== undefined && typeof e === 'string') {
                            setSign(e as '=' | '<' | '>' | '><' | undefined)
                            // dispatch(setFindAllPeopleFiltersRevenue(revenueOptions.find(option => option.value === e)));
                        }
                    }}
                    defaultValue={sign}
                    placeholder={"Uguale, minore, maggiore, compreso"}
                    options={signOptions}
                />
                {sign !== undefined && (
                    <div className="flex gap-2">
                        <NumericFormat
                            key={"people-filter-revenue-input-1"}
                            prefix="€ "
                            defaultValue={firstInput?.toLocaleString('it-IT', { useGrouping: true })}
                            thousandSeparator="."
                            decimalSeparator=","
                            decimalScale={2}
                            fixedDecimalScale
                            autoComplete="off"
                            onValueChange={(e) => {
                                setFirstInput(e.floatValue);
                            }}
                            className="h-[44px] ring-0 outline-none focus:border-neutral-300 focus:bg-white bg-white border-[1px] border-neutral-300 rounded-lg w-full placeholder:text-label-sm placeholder:text-neutral-400 text-label-sm text-neutral-600 font-medium"
                            id={"people-filter-revenue-input-1"}
                            placeholder={signOptions.find(rev => rev.value === sign)?.label}
                        />
                        {
                            sign === '><' &&
                            <NumericFormat
                                key={"people-filter-revenue-input-2"}
                                prefix="€ "
                                autoComplete="off"
                                defaultValue={secondInput?.toLocaleString('it-IT', { useGrouping: true })}
                                thousandSeparator="."
                                decimalSeparator=","
                                decimalScale={2}
                                onValueChange={(e) => {
                                    setSecondInput(e.floatValue);
                                }}
                                className="h-[44px] ring-0 outline-none focus:border-neutral-300 active:bg-white autofill:bg-white focus:bg-white bg-white border-[1px] border-neutral-300 rounded-lg w-full placeholder:text-label-sm placeholder:text-neutral-400 text-label-sm text-neutral-600 font-medium"
                                id={"people-filter-revenue-input-2"}
                                placeholder={"Compreso tra"}
                            />
                        }
                    </div>
                )}
            </div>
        </AccordionFilter>
    );
}
